module.exports = __webpack_public_path__ + "static/media/readAll.c1da6bae.svg";